// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { Props } from './types';
import TextArea from 'presentations/views/components/atoms/TextArea';

export default function FeedbackTextarea(props: Props) {
  const t = translateInComponent(translations);

  return (
    <TextArea
      isRequired={false}
      isNotRequired={true}
      isAutoFocus={true}
      isFullWidth
      name="cancelFeedback"
      value={props.value}
      placeholder={t('placeholder')}
      onChange={props.onChange}
    />
  );
}
